import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`ri-star-fill text-sm ${
            star <= rating ? 'text-accent-500' : 'text-background-300'
          }`}
        />
      ))}
    </div>
  );
}

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const visibleCount = 3;

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
            Loved by Our Guests
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            What People Say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.slice(activeIndex, activeIndex + visibleCount).map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/60"
            >
              <StarRating rating={t.rating} />
              <p className="text-foreground-700 text-base leading-relaxed mt-4 mb-6 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-600 font-semibold text-sm">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-label text-sm font-semibold text-foreground-900">
                    {t.name}
                  </p>
                  <p className="text-foreground-500 text-xs">{t.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {testimonials.length > visibleCount && (
          <div className="flex items-center justify-center gap-2 mt-8">
            {Array.from({ length: Math.ceil(testimonials.length / visibleCount) }).map(
              (_, i) => (
                <button
                  key={i}
                  onClick={() => setActiveIndex(i * visibleCount)}
                  className={`w-2.5 h-2.5 rounded-full transition-colors ${
                    i === Math.floor(activeIndex / visibleCount)
                      ? 'bg-primary-500'
                      : 'bg-background-300 hover:bg-background-400'
                  }`}
                  aria-label={`Go to testimonial page ${i + 1}`}
                />
              )
            )}
          </div>
        )}
      </div>
    </section>
  );
}